import axios from 'axios';

// Desarrollo siempre consume la API local. Producción toma la URL del archivo
// .env.production y no permite que una variable local altere el servidor de dev.
axios.defaults.baseURL = process.env.NODE_ENV === 'production'
  ? process.env.VUE_APP_API_URL
  : 'http://localhost:3010';

const AUTH_STORAGE_KEYS = ['token', 'userRole', 'userId', 'userName', 'businessId', 'businessName', 'mustChangePassword'];
const OPERATOR_STORAGE_KEYS = ['posOperatorToken', 'posOperator', 'posOperatorPermissions'];

function clearAuthSession() {
  AUTH_STORAGE_KEYS.forEach(key => localStorage.removeItem(key));
  OPERATOR_STORAGE_KEYS.forEach(key => sessionStorage.removeItem(key));
}

axios.interceptors.request.use(
  config => {
    const operatorToken = sessionStorage.getItem('posOperatorToken');
    const token = operatorToken || localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
      config.__usedOperatorToken = Boolean(operatorToken);
    }
    return config;
  },
  error => Promise.reject(error)
);

axios.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const isLoginRequest = requestUrl.includes('/api/auth/login');
    const isOperatorLoginRequest = requestUrl.includes('/api/tenant/pos/operator-login');

    if (status === 401 && !isLoginRequest && !isOperatorLoginRequest) {
      if (error.config?.__usedOperatorToken) {
        OPERATOR_STORAGE_KEYS.forEach(key => sessionStorage.removeItem(key));
        if (window.location.pathname !== '/operator-select') {
          window.location.replace('/operator-select');
        }
      } else {
        clearAuthSession();
        const path = window.location.pathname;
        if (path !== '/login' && path !== '/change-password') {
          window.location.replace('/login');
        }
      }
    }

    return Promise.reject(error);
  }
);

export default axios; 